import { combineReducers } from 'redux';
import auditLogReducer from '../auditLogReducer';
import accessLogReducer from './accessLogReducer';

/* global Redux */
const aesToolsReducer = function() {
  return combineReducers({
    accessLog: accessLogReducer,
    auditLog: auditLogReducer,
  });
};

export default aesToolsReducer();
